export default () => {
  const forms = document.querySelectorAll('.js-newsletter-form');
  const re    = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  forms.forEach(form => {
    let email = form.querySelector('.js-newsletter-email');

    form.addEventListener('submit', e => {
      e.preventDefault();

      if (re.test(email?.value)) {
        form.classList.remove('has-error');
        form.submit();
      } else {
        form.classList.add('has-error');
      }
    });

    email.addEventListener('focus', () => {
      form.classList.remove('has-error');
    });
  });
}